import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from '@/views/Home'
import ProductCard from '@/views/ProductCard'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/catalog/view/:id',
      component: ProductCard,
      props: true
    },
    {
      path: '*',
      component: Home
    }
  ]
})

export default router
